export const ROUTER = {
  OVERVIEW: {
    path: '/overview',
    name: 'Overview',
  },
  LOGIN: {
    path: '/login',
    name: 'Login',
  },
  RESET_PASS: {
    path: '/reset-password',
    name: 'ResetPassword',
  },
  RESET_PASS_BY_EMAIL: {
    path: '/reset-password-by-email',
    name: 'ResetPasswordByEmail',
  },
  SIGN_UP: {
    path: '/signup',
    name: 'SignUp',
  },
  SIGN_OUT_THANK_YOU: {
    path: '/signout-thankyou',
    name: 'SignOutThankYou',
  },
  NEW_CAMPAIGN: {
    path: '/new-campaign',
    name: 'NewCampaign',
  },
  EDIT_CAMPAIGN: {
    path: '/edit-campaign',
    name: 'EditCampaign',
  },
  CREATE_CAMPAIGN_SUCCESS: {
    path: '/create-campaign-success',
    name: 'CreateCampaignSuccess',
  },
  DETAILS_CAMPAIGN: {
    path: '/campaign-details',
    name: 'CampaignDetails',
  },
  ACCOUNT_SETTINGS: {
    path: '/account-settings',
    name: 'Account Settings',
  },
  SYSTEM_HISTORY: {
    path: '/system-history',
    name: 'SystemHistory',
  }
};
